export default {
	sec_01: {
		title: {
			one: '이용하는 방법',
			two: '',
			three: '오프라인 가맹점을',
		},
		desc: {
			one: '고객이 직접 빠른 결제가 가능합니다.',
			two: '현금이나 카드 없이 휴대폰만 있으면 즉시 결제가 가능한',
			three: 'JP WOLRD Pay를 사용해 보시기 바랍니다.',
		},
		btn: {
			one: '회원가입하기',
			two: '로그인',
		},
	},
	sec_02: {
		title: {
			one: 'JP WOLRD 를 이용한 결제방법',
		},
		step: {
			one: {
				one: '휴대폰에서',
				two: 'JP WOLRD Pay를',
				three: '선택하고 실행하세요.',
			},
			two: {
				one: '지갑을 선택해서',
				two: '‘오프라인 상점 결제’를 선택하세요.',
			},
			three: {
				one: 'QR코드를 키오스크에',
				two: '스캔하시면 결제 끝.',
			},
		},
	},
	sec_04: {
		title: '미래화폐 시스템에 오신 것을 환영합니다.',
		cards: {
			one: {
				title: '안전한 결제',
				description: {
					one: '오프라인 결제 시',
					two: '고객님의 정보가 남지 않습니다.',
				},
			},
			two: {
				title: '가까운 가맹점에서',
				description: {
					one: '언제 어디서나 JP WOLRD Pay가',
					two: '가맹 된 곳을 찾아 사용하세요.',
				},
			},
			three: {
				title: '현금없이',
				description: {
					one: '아직도 현금을 들고 다니시나요?',
					two: '휴대폰에서 JP WOLRD Pay를 바로 사용하세요.',
				},
			},
		},
	},
	sec_05: {
		title: '판매자도 쉽게 접근하세요.',
		desc: {
			one: 'JP WOLRD Pay 키오스크에 판매 물품만 등록하면 끝.',
			two: '결제는 JP WOLRD Pay 키오스크가 해드립니다.',
		},
	},
};
